const $ = window.jQuery || {};

class PopupManager {
  constructor(options) {
    this.options = $.extend(
      {
        title: "",
        content: "",
        closeButton: true,
      },
      options
    );

    this.init();
  }

  init() {
    this.createOverlay();
    this.createPopup();
    this.bindEvents();
  }

  createOverlay() {
    this.$overlay = $(".popup-overlay");
    if (this.$overlay.length === 0) {
      this.$overlay = $('<div class="popup-overlay"></div>');
      $("body").append(this.$overlay);
    }
    this.$overlay.hide();
  }

  createPopup() {
    this.$popup = $(".popup-window");
    if (this.$popup.length === 0) {
      this.$popup = $(`
                <div class="popup-window">
                    <div class="popup-header">
                        <h2 class="popup-title">${this.options.title}</h2>
                        ${
                          this.options.closeButton
                            ? '<span class="popup-close">&times;</span>'
                            : ""
                        }
                    </div>
                    <div class="popup-content">
                        ${this.options.content}
                    </div>
                </div>
            `);
      $("body").append(this.$popup);
    } else {
      // Update content if popup already exists
      this.$popup.find(".popup-title").html(this.options.title);
      this.$popup.find(".popup-content").html(this.options.content);
    }
    this.$popup.hide();
  }

  bindEvents() {
    if (this.options.closeButton) {
      this.$popup
        .off("click", ".popup-close")
        .on("click", ".popup-close", () => this.close());
    }
    this.$overlay.off("click").on("click", () => this.close());
  }

  open() {
    this.$overlay.fadeIn();
    this.$popup.fadeIn();
  }

  close() {
    this.$overlay.fadeOut();
    this.$popup.fadeOut();
  }
}

export default PopupManager;
